<template>
  <div class="partner">
    <div class="shadow"></div>
    <!-- 主体内容部分 （政策标准 通知公告 教学资源 证书信息）布局样式-->
    <div class="certificate-list">
      <!-- 左侧 -->
      <div class="certificate-list-left">
        <div class="toobar">
          <div class="eng">INFOSERCH</div>
          <div class="eng-font">信息查询</div>
        </div>
          <div
          :class="pindex == index ? 'column2' : 'column1'"
          v-for="(item,index) in barList"
          :key="index"
        >
        <div @click="categoryChange(index)">{{item.name}}</div>
          <div v-if="pindex == index" style="float: right;margin-right: 20px;">></div>
        </div>
      </div>

      <!-- 右侧 -->
      <div class="certificate-list-right">
        <div v-if="this.tabChangeNum == 0">
          <div class="titleList">
            <div v-if="searchFlag" class="searchStyle">
              <img
                onclick="window.open('https://vslc.ncb.edu.cn/gateway/queryGradeEntry')"
                style="cursor: pointer"
                src="https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/chengjichaxun1.png"
                onmouseover="this.src='https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/chengjichaxun.png'"
                onmouseout="this.src='https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/chengjichaxun1.png'"
              />
              <img
                onclick="window.open('https://vslc.ncb.edu.cn/gateway/datadetails')"
                style="cursor: pointer"
                src="https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/zhengshuchaxun.png"
                onmouseover="this.src='https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/zhengshuchaxun1.png'"
                onmouseout="this.src='https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/zhengshuchaxun.png'"
              />
            </div>
            <div v-if="!searchFlag" class="tablecont">
              <div class="fanhui" @click="fanhui()">返 回</div>
              <div class="serchbox" style="margin: 20px 0">
                <div class="serchitem">
                  <div class="serchname">考生姓名:</div>
                  <div class="serchinput">
                    <input v-model="serchname" type="text" />
                  </div>
                </div>
                <div class="serchitem">
                  <div class="serchname">准考证号:</div>
                  <div class="serchinput" style="width: 250px">
                    <input v-model="serchid" type="text" />
                  </div>
                </div>
                <div class="serchbtn" @click="serchfn">查询</div>
              </div>
              <div class="serchcont">
                <div class="studentinfo">
                  <div class="infoitem">
                    <div class="infoname">考试名称</div>
                    <div class="infoval">{{ examPlan }}</div>
                  </div>
                  <div class="infoitem">
                    <div class="infoname">考生姓名</div>
                    <div class="infoval">{{ studentName }}</div>
                  </div>
                  <div class="infoitem">
                    <div class="infoname">准考证号</div>
                    <div class="infoval">{{ admissionCardNum }}</div>
                  </div>
                  <div class="infoitem">
                    <div class="infoname">理论成绩</div>
                    <div
                      :class="
                        shicaoScore.length > 3 ? 'infoval_color' : 'infoval'
                      "
                    >
                      {{ lilunScore }}
                    </div>
                  </div>
                  <div class="infoitem">
                    <div class="infoname">实操成绩</div>
                    <div
                      :class="
                        shicaoScore.length > 3 ? 'infoval_color' : 'infoval'
                      "
                    >
                      {{ shicaoScore }}
                    </div>
                  </div>
                  <div class="infoitem">
                    <div class="infoname">考核机组</div>
                    <div class="infoval">{{ jizu }}</div>
                  </div>
                  <div class="infoitem">
                    <div class="infoname">学校名称</div>
                    <div class="infoval">{{ schoolName }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="this.tabChangeNum == 1" class="tabChangeInfo">
          <div v-if="searchFlag" class="searchStyle">
            <img
              @click="searchStyleChange(1)"
              style="cursor: pointer"
              src="https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/jiaoshipeixun.png"
              onmouseover="this.src='https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/jiaoshipeixun1.png'"
              onmouseout="this.src='https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/jiaoshipeixun.png'"
            />
            <img
              @click="searchStyleChange(2)"
              style="cursor: pointer"
              src="https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/kaopingyuan1.png"
              onmouseover="this.src='https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/kaopingyuan.png'"
              onmouseout="this.src='https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/kaopingyuan1.png'"
            />
          </div>
          <div v-if="!searchFlag" class="tablecont">
            <div class="fanhui" @click="fanhui()">返 回</div>
            <div style="margin: 50px 0; font-size: 24px; text-align: center">
              <span v-if="searchStyle1 == 1">培训教师证书查询</span>
              <span v-if="searchStyle2 == 1">考评员证书查询</span>
            </div>
            <div class="serchbox">
              <div class="serchitem">
                <div class="serchname">教师姓名:</div>
                <div class="serchinput">
                  <input v-model="teacherName" type="text" />
                </div>
              </div>
              <div class="serchitem">
                <div class="serchname">证书编号:</div>
                <div class="serchinput" style="width: 250px">
                  <input v-model="cardNum" type="text" />
                </div>
              </div>
              <div class="serchbtn" @click="serchfn">查询</div>
            </div>
            <div style="height: 60px"></div>
            <img
              v-if="searchStyle1 == 1"
              style="width: 90%"
              :src="searchImgUrl"
              alt
            />
            <img
              v-if="searchStyle2 == 1"
              style="width: 40%; margin: auto"
              :src="searchImgUrl"
              alt
            />
            <div style="height: 40px"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Article,
  ArChildren,
  timestampToTime,
  Serchdata,
} from "../../services/article";
export default {
  data() {
    return {
      barList:[{name:'1+X证书查询'},{name:'1+X师资培训证书查询'}],
      i: 0,
      pindex: 0,
      tabChangeNum: 0,
      searchFlag: true,
      admissionCardNum: "",
      cardNum: "",
      studentName: "",
      examPlan: "",
      kaohe: "",
      lilunScore: "",
      shicaoScore: "",
      jizu: "",
      serchname: "", //查询名字
      serchid: "", //查询id
      schoolName: "",
      teacherName: "",
      searchStyle1: 1, // 查询类型（默认为0）
      searchStyle2: 0, // 查询类型（默认为0）
      menuList: [
        {
          id: "137",
          name: "政策标准",
          path: "/certificatechildren",
        },
        {
          id: "138",
          name: "通知公告",
          path: "/notice",
        },
        {
          id: "139",
          name: "师资培训",
          path: "/train",
        },
        {
          id: "140",
          name: "教学资源",
          path: "/resource",
        },
        {
          id: "141",
          name: "证书信息",
          path: "/certificateInfo",
        },
        {
          id: "142",
          name: "学分银行",
          path: "/creditbank",
        },
        {
          id: "143",
          name: "信息查询",
          path: "/inqure",
        },
      ],

      /**
       * 一级分类子菜单
       * cate_id:分类子菜单id
       * name:分类子菜单名称
       * 测试数据 部署时清空
       */
      dataList: [],
    };
  },
  mounted() {
    let that = this;
    let clickId = that.$route.query.id;
    that.menuClick(6);
    if (!clickId) {
      that.categoryChange(0);
    } else {
      that.categoryChange(clickId);
    }
  },
  watch: {
    $route: {
      handler() {
        if ((this.id = this.$route.query.id)) {
          this.categoryChange(this.$route.query.id);
        }
        //深度监听，同时也可监听到param参数变化
      },
      deep: true,
    },
  },
  methods: {
    // 查询函数
    serchfn() {
      if (this.tabChangeNum == 1 && this.searchStyle1 == 1) {
        let url =
          "http://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/peixunjiaoshi/" +
          this.teacherName +
          "-" +
          this.cardNum +
          ".png";
        this.validateImage(url);
      } else if (this.tabChangeNum == 1 && this.searchStyle2 == 1) {
        let url =
          "http://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/kaopingyuan/" +
          this.teacherName +
          "-" +
          this.cardNum +
          ".png";
        this.validateImage(url);
      } else {
        this.studentName = "";
        this.admissionCardNum = "";
        this.shicaoScore = "";
        this.lilunScore = "";
        this.kaohe = "";
        this.schoolName = "";
        this.jizu = "";
        Serchdata({
          StudentName: this.serchname,
          admissionCardNum: this.serchid,
        }).then((res) => {
          //console.log(res, "res");
          if (res.list != null && res.list.length > 0) {
            this.userinfo = res.list;
            this.studentName = this.serchname;
            this.admissionCardNum = this.serchid;
            for (let i = 0; i < this.userinfo.length; i++) {
              this.examPlan = this.userinfo[i].examPlan;
              this.schoolName = this.userinfo[i].school;
              this.jizu = this.userinfo[i].jizu;
              if (this.userinfo[i].examSubject.indexOf("理论") > -1) {
                //console.log(this.userinfo);
                this.lilunScore = this.userinfo[i].score;
                this.userinfo[i]["islilun"] = true;
              } else {
                this.userinfo[i]["islilun"] = false;
                this.shicaoScore = this.userinfo[i].score;
              }
            }
          } else {
            this.examPlan = "";
            this.studentName = this.serchname;
            this.admissionCardNum = this.serchid;
            this.shicaoScore = "未查询到您的成绩！";
            this.lilunScore = "未查询到您的成绩！";
            this.kaohe = "未通过！";
            this.schoolName = "";
            this.jizu = "";
          }

          //console.log(this.userinfo);

          if (this.shicaoScore >= 60 && this.lilunScore >= 60) {
            this.kaohe = "通过！";
            //console.log("通过");
          } else {
            this.kaohe = "未通过！";
            //console.log("未通过");
          }
        });
      }
      //   var res = Serchdata({ StudentName: this.serchname, idNum: this.serchid });
      //   //console.log(res);
      //   //console.log(res.PromiseResult);
      //   this.userinfo = res.list;
    },
    validateImage(url) {
      var ImgObj = new Image(); //判断图片是否存在
      ImgObj.src = url;
      var that = this;
      ImgObj.onload = function (res) {
        that.searchImgUrl = url;
      };
      ImgObj.onerror = function (err) {
        alert("未查询到相关信息!");
        return;
      };
    },
    fanhui() {
      this.categoryChange(this.tabChangeNum);
    },
    searchStyleChange(index) {
      this.searchFlag = false;
      this.searchImgUrl = "";
      if (index == 1) {
        this.searchStyle1 = 1;
        this.searchStyle2 = 0;
      } else if (index == 2) {
        this.searchStyle1 = 0;
        this.searchStyle2 = 1;
      }
    },
    menuClick(index) {
      this.searchFlag = true;
      this.searchImgUrl = "";
      this.sourceFlag = true;
      this.pageIndex = 1; //初始化页码
      this.activeName = index; //改变选项卡样式
      this.pindex = 0; //改变二级菜单样式
      //console.log(index, this.menuList, "一级分类标题点击事件");
      // 学分银行不执行
      if (index == 5 || index == 4 || index == 6) {
        this.dataList = [];
        return;
      }
      //师资培训 直接查询文章
      // if(index==2){
      // 	this.videoIndex=0;//video-mini-list开始下标
      // 	this.playIndex=0;//video-main所显示播放列表中的视频内容
      // 	this.videoFlag=true;
      // 	let cid = this.menuList[index].id;
      // 	this.article(cid,1);
      // }else{
      let dataList = [];
      this.dataList = [];
      let pid = this.menuList[index].id;
      //console.log(this.menuList, "res1");

      // }
    },
    categoryChange(index) {
      //根据设置动态路由，展示不同页面
      this.$router.push({
        path: "/inqure",
        query: {
          id: index,
        },
      });

      //根据tab页面切换，展示不同页面
      this.tabChangeNum = index;
      // 修改左侧导航栏的样式
      this.pindex = index;
      //初始化searchStyle值
      this.searchStyle1 = 1;
      this.searchStyle2 = 0;
      this.searchImgUrl = "";
      this.searchFlag = true;
    },
  },
};
</script>

<style scoped>
.shadow {
  height: 100px;
  width: 100%;
  background-color: #d7d7d7;
}
.certificate-list-right {
  position: relative;
  display: inline-block !important;
  width: 1014px;
  height: 455px;
  border-left: 1px solid #d4d4d4;
}
.tablecont {
  width: 100%;
  margin-left: 50px;
}

.serchbox {
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 14px;
}

.serchitem {
  margin: 0 20px;
  display: flex;
  line-height: 40px;
}

.fanhui {
  display: inline-block;
  color: #606266;
  background: #fff;
  border: 1px solid #dcdfe6;
  padding: 10px 12px;
  text-align: start;
}

.fanhui:hover {
  color: #528ce0;
  cursor: pointer;
  border: 1px solid #599af5;
}
.serchbtn {
  width: 120px;
  height: 40px;
  line-height: 40px;
  background-color: #0055d3;
  color: white;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 20px;
}
.serchinput {
  width: 120px;
  height: 40px;
  padding: 2px 10px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-left: 10px;
}

.serchinput > input {
  border: none;
  outline: none;
  width: 100%;
  height: 80%;
  position: relative;
  top: -4px;
}
.studentinfo {
  width: 92%;
  background-color: rgb(246, 249, 254);
  border-top: 1px solid rgb(200, 219, 250);
  border-left: 1px solid rgb(200, 219, 250);
  margin-top: 30px;
  font-size: 14px;
  margin-bottom: 30px;
}
.infoitem {
  width: 100%;
  display: flex;
  text-align: center;
  border-bottom: 1px solid rgb(200, 219, 250);
}
.infoname,
.infoval {
  width: 40%;
  border-right: 1px solid rgb(200, 219, 250);
  padding: 15px 0;
}
.infoval_color {
  width: 60%;
  border-right: 1px solid rgb(200, 219, 250);
  padding: 15px 0;
  color: red;
}

.infoval {
  width: 60%;
}
.titleList {
  height: auto;
  width: auto;
  margin-top: 30px;
}
.partner {
  background-color: white;
}
.column1 {
  height: 52px;
  width: auto;
  font-size: 14px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
}
.column2 {
  height: 52px;
  width: auto;
  font-size: 14px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  color: #0055d3;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
}
.column1:hover,
.column2:hover {
  color: #0055d3;
  cursor: pointer;
}
</style>
